import { useAuth } from "@/auth.tsx";
import { AgentBuilderForm } from "@/components/agents/agent-builder-form.tsx";
import { mayCreateAgents } from "@/components/agents/agent-policy.ts";
import { useAgentPolicy } from "@/components/agents/use-agent-policy.ts";
import {
	readAgentDraft,
	readAgentSchedule,
} from "@/components/agents/wizard/wizard-logic.ts";
import { m } from "@/paraglide/messages.js";
import { createFileRoute, Navigate, useLocation } from "@tanstack/react-router";
import { useState } from "react";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/agents/new")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_builder_create()) }],
	}),
});

function RouteComponent() {
	const { user } = useAuth();
	const policy = useAgentPolicy();
	const state = useLocation({ select: (location) => location.state });
	// Read once: the form seeds from it on mount and owns the values after.
	const [draft] = useState(() => readAgentDraft(state));
	const [schedule] = useState(() => readAgentSchedule(state));
	// The catalogue hides its create button from a member the org does not let
	// create agents; a deep link lands back there rather than on a form whose
	// save the server refuses.
	if (!mayCreateAgents(policy, user?.isAdmin ?? false)) {
		return <Navigate to="/dashboard/agents" replace />;
	}
	return (
		<AgentBuilderForm
			agent={null}
			initialValues={draft ?? undefined}
			suggestedSchedule={schedule}
		/>
	);
}
